import { render } from "./StartPageLayout.vue?vue&type=template&id=d6cc28d6&scoped=true"
import script from "./StartPageLayout.vue?vue&type=script&lang=js"
export * from "./StartPageLayout.vue?vue&type=script&lang=js"

import "./StartPageLayout.vue?vue&type=style&index=0&id=d6cc28d6&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6cc28d6"]])

export default __exports__